import React from "react";
import * as utils from "./generic";

// import { utils } from "zebulon-controls";
// import {
// 	buildObject,
// 	exportFunctions
// 	// aggregations
// } from "./utils/utils";
// import { getFunction } from "./utils/compute.meta";
// ({row})=>accessor('qty')({row})*3
var sum = function sum(values) {
	return values.reduce(function (sum, value) {
		return sum += value;
	}, null);
};
var accessors = {
	globals_: {
		formats: {
			decimals: function decimals(_ref) {
				var value = _ref.value,
				    _decimals = _ref.decimals,
				    column = _ref.column;
				return utils.formatValue(value, null, _decimals || (column || {}).decimals || 2);
			},
			percentage: function percentage(_ref2) {
				var value = _ref2.value,
				    decimals = _ref2.decimals,
				    column = _ref2.column;
				return utils.formatValue(value * 100, null, decimals || (column || {}).decimals || 2) + "%";
			},
			date: function date(_ref3) {
				var value = _ref3.value,
				    format = _ref3.format,
				    column = _ref3.column;
				return utils.isNullOrUndefined(value) ? "" : utils.formatValue(value, format || (column || {}).format || "dd/mm/yyyy");
			},
			"mm/yyyy": function mmYyyy(_ref4) {
				var value = _ref4.value;
				return utils.isNullOrUndefined(value) ? "" : utils.formatValue(value, "mm/yyyy");
			},
			yyyy: function yyyy(_ref5) {
				var value = _ref5.value;
				return utils.isNullOrUndefined(value) ? "" : utils.formatValue(value, "yyyy");
			},
			time: function time(_ref6) {
				var value = _ref6.value;
				return utils.isNullOrUndefined(value) ? "" : utils.formatValue(value, "hh:mi:ss");
			},
			dateTime: function dateTime(_ref7) {
				var value = _ref7.value;
				return utils.isNullOrUndefined(value) ? "" : utils.formatValue(value, "dd/mm/yyyy hh:mi:ss");
			},
			image: function image(_ref8) {
				var value = _ref8.value;

				if (!value) {
					return null;
				}
				return React.createElement("img", {
					height: "100%",
					width: "100%",
					padding: "unset",
					alt: "",
					src: value
				});
			}
		},
		aggregations: {
			count: function count(values) {
				return values.length;
			},
			sum: sum,
			min: function min(values) {
				return values.reduce(function (min, value) {
					return min = min === null || value < min ? value : min;
				}, null);
			},
			max: function max(values) {
				return values.reduce(function (max, value) {
					return max = max === null || value > max ? value : max;
				}, null);
			},
			avg: function avg(values) {
				return values.length === 0 ? null : sum(values) / values.length;
			},
			weighted_avg: function weighted_avg(values) {
				var wavg = values.reduce(function (wavg, value) {
					wavg.v0 += value.v0;
					wavg.v1 += value.v1;
					return wavg;
				}, { v0: null, v1: null });
				return wavg.v0 === null && wavg.v1 === null ? null : wavg.v0 / wavg.v1;
			},
			delta: function delta(values) {
				var delta = values.reduce(function (delta, value) {
					delta.v0 += value.v0;
					delta.v1 += value.v1;
					return delta;
				}, { v0: null, v1: null });
				return delta.v0 - delta.v1;
			},
			prod: function prod(values) {
				return values.reduce(function (prod, value) {
					return prod *= value;
				}, null);
			}
		}
	}
};
// function forEachIntersection(accessor, intersection, data, callback) {
//   if (intersection && intersection.length > 0) {
//     // for (let i = 0; i < intersection.length; i += 1) {
//     //   const row=data[intersection[i]];
//     //   callback(accessor(row));
//     // }
//     intersection.map(index=>{const row =data[index];
//       if(!row.isFiltered){callback(accessor(row))};
//   }
// }

// export function calcVariance(accessor, intersection, data, population) {
//   let variance = 0;
//   let avg = null;
//   const len = intersection.length;
//   if (len > 0) {
//     if (population || len > 1) {
//       forEachIntersection(accessor, intersection, data, val => {
//         avg += val;
//       });
//       avg /= len;
//       forEachIntersection(accessor, intersection, data, val => {
//         variance += (val - avg) * (val - avg);
//       });
//       variance /= population ? len : len - 1;
//     } else {
//       variance = NaN;
//     }
//   }
//   return variance;
// }

export { accessors };


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/utils/accessors.js
// module id = 298
// module chunks = 0